window.zeroLastNumber = function (number) {
    let s = number.toString();
    s = s.substring(0, s.length - 1);
    s += "0";
    return parseInt(s);
}